import React, { useState, useEffect } from 'react'
// import Modal from '../../common-components/button'
import { ModalBody, Modal } from 'reactstrap'
import ConsentTakeAPhoto from './componets/ConsentTakeAPhoto'
import ConsentAllow from './componets/ConsentAllow'
import ImagePreview from './componets/ImagePreview'
import AsyncLoadding from './componets/AsyncLoadding'
import OCRCamera from './OCRCamera'
import Icon from 'e-submission/components/Icon'
import ktaxaLogo from '!url-loader!assets/images/logo-ktaxa-th-bordered.png'
import { state_action } from './ActionHelper'

const ModalOCR = ({ isOpen, payerModalSelcted, typemodal, onExit, onSaveImageOCR }) => {
  const [statePage, setStatePage] = useState(state_action.consentinfo)
  const data = ''
  const [camaraStream, setCamaraStream] = useState(null)
  const [DataImage, setDataImage] = useState(data)
  const [CountCallAPIFail, setCountCallAPIFail] = useState(0)

  const onNextPage = (currentpage, image) => {
    if (image != null) {
      setDataImage(image)
    }
    if (camaraStream) {
      camaraStream.getTracks().forEach((track) => track.stop())
    }
    if (currentpage == state_action.doneflow) {
      setStatePage(state_action.consentinfo)
      onExit()
    } else {
      setStatePage(currentpage)
    }
  }

  const onAPIFail = () => {
    setCountCallAPIFail(CountCallAPIFail + 1)
  }

  return (
    <Modal
      fullscreen={false}
      isOpen={isOpen}
      toggle={() => {
        setStatePage(state_action.consentinfo)
        setCountCallAPIFail(0)
        if (camaraStream) {
          camaraStream.getTracks().forEach((track) => track.stop())
        }
        onExit()
      }}
    >
      {statePage != state_action.loadingapi ? (
        <div
          style={{
            width: '100%',
            height: 90,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderBottom: '1px solid #33333322',
          }}
        >
          <div
            style={{
              width: '80%',
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              paddingLeft: window.innerWidth * 0.2,
            }}
          >
            <img src={ktaxaLogo} style={{ width: 100 }} />
          </div>

          <div
            style={{
              width: '20%',
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Icon.close
              className="icon"
              onClick={() => {
                setStatePage(state_action.consentinfo)
                setCountCallAPIFail(0)
                if (camaraStream) {
                  camaraStream.getTracks().forEach((track) => track.stop())
                }
                onExit()
              }}
            />
          </div>
        </div>
      ) : (
        <></>
      )}
      <ModalBody
        style={{
          width: '100%',
        }}
      >
        {statePage == state_action.consentinfo && (
          <ConsentAllow onNextPage={onNextPage} payerModalSelcted={payerModalSelcted} typemodal={typemodal} />
        )}
        {statePage == state_action.camerainfo && <ConsentTakeAPhoto onNextPage={onNextPage} />}
        {statePage == state_action.previewimage && (
          <ImagePreview onNextPage={onNextPage} DataImage={DataImage} typemodal={typemodal} />
        )}
        {statePage == state_action.loadingapi && (
          <AsyncLoadding
            onNextPage={onNextPage}
            onSaveImageOCR={onSaveImageOCR}
            onAPIFail={onAPIFail}
            CountCallAPIFail={CountCallAPIFail}
            onExit={onExit}
            typemodal={typemodal}
            DataImage={DataImage}
          />
        )}
        {statePage == state_action.opencamera_onweb && (
          <OCRCamera
            onNextPage={onNextPage}
            DataImage={DataImage}
            typemodal={typemodal}
            setCamaraStream={setCamaraStream}
          />
        )}
      </ModalBody>
    </Modal>
  )
}

export default ModalOCR
